<template>
    <div class="md user-notification" :class="[show? 'is-active': '', length? 'has-notification': '']">
        <a @click.prevent.stop="toggle()" :title="$t('site.func.notification')" id="notification">
            <span v-if="length">{{ length }}</span>
        </a>
        <transition name="animate">
            <ul v-if="show" class="func" @click.stop>
                <li
                    v-for="item in userNotificationList"
                    :class="[item.is_read? '': 'not-yet']"
                    :key="item['data-id']"
                >
                    <a
                        class="div"
                        @click="showMsg(item)"
                    >
                        <div
                            v-if="item.img"
                            class="image"
                            :style="'background-image: url('+ item.img +')'"
                        ></div>
                        <div
                            v-else
                            class="image is-alert"
                        ></div>
                        <div class="essay">
                            <div class="caption">{{ item.title }}</div>
                            <div class="p">{{ item.body }}</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        class="last"
                        @click="goNotification"
                    >{{ $t('site.func.more') }}</a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        data: function(){

            return {
                id: 'user-notification',
                show: false
            }
        },
        computed: {
            ...mapState([
                'user',
                'userNotification',
            ]),
            length: function() {
                let $userNotification = this.userNotificationList,
                    $filter = $userNotification.filter(item => !item.is_read);

                return $filter.length || 0
            },
            userNotificationList: function(){
                return this.userNotification.slice(0, 6);
            }
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
                'userNotificationGet',
                'pushPopUp',
            ]),
            showMsg: function(item){
                item.is_read = true;
                this.hide();

                if( item.url ) {
                    this.userNotificationGet(item['data-id']);
                    this.$router.push(item.url);
                }else {
                    this.userNotificationGet(item['data-id']);

                    this.pushPopUp({
                        type: 'alert',
                        content: {
                            caption: item.title,
                            html: item.body,
                        }
                    });
                }
            },
            goNotification: function(){
                this.hide();
                this.$router.push('/system/account?page=notification');
            },
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
            },
            hide: function(){
                this.show = false;
            },
        },
        created: function(){
            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .md.user-notification {
        @extend %header-btn-caption;

        &.is-active {

            > a {
                background-color: $major-color;
            }
        }

        &.has-notification {

            > a {

                &::before {
                    content: '\e7f4';
                }
            }
        }

        > a {
            position: relative;

            &::before {
                content: '\e7f5';
            }

            span {
                @extend %notification-span;
                
                top: -1 * $interval-xs;
                right: -1 * $interval-xs;
            }
        }

        ul.func {
            @extend %reset;
            @extend %drop-caption;
            display: block;
            top: 100%;
            right: 0;
            margin-top: 0;
            padding: $interval-m;
            max-height: calc(100vh - 80px);
            overflow: auto;

            @include media('phone') {
                position: fixed;
                top: 50px;
                left: 0;
                right: 0;
                bottom: 0;
                max-height: none;
            }

            $type: map-get($colors, 'danger');
            $text: map-get($type, 'text');

            li {
                width: 300px;

                @include media('phone') {
                    width: auto;
                }

                + li {
                    margin-top: $interval-s;
                    
                    /*a*/.last {
                        border-top: $border;
                        padding-top: $interval-m;
                    }
                }

                &.not-yet {
                    
                    /*a*/.div {

                        .image {
                            box-shadow: 0 0 0 2px $text inset;
                        }

                        &::before {
                            content: $content;
                        }
                    }
                }

                a {
                    cursor: pointer;
                }
            }

            $size: 50px;
            
            /*a*/.div {
                display: block;
                position: relative;
                min-height: $size;
                padding: $interval-s;
                color: inherit;
                transition: $transition;

                &:hover {
                    background-color: $light;
                }

                &::before {
                    position: absolute;
                    top: 9px;
                    left: 9px;
                    width: $interval-m;
                    height: $interval-m;
                    border-radius: 50%;
                    background-color: $text;
                    z-index: 1;
                }
            }

            /*a*/.last {
                display: block;
                text-align: center;

                &:hover {
                    text-decoration: underline;
                }
            }

            .image {
                position: absolute;
                top: $interval-s;
                left: $interval-s;
                width: $size;
                height: $size;
                border-radius: 50%;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                background-color: $minor-color;

                &.is-alert {
                    background-image: image-url('alert.svg');
                    background-size: 80%;
                }
            }

            .essay {
                position: relative;
                padding-left: $size + $interval-s * 2;
                transition: $transition;
                flex: 1;

                .caption {
                    font-size: $font-size-l;
                }

                .p {
                    color: $major-color;
                }
            }
        }
    }
</style>
